import './App.css';
import '../shared/components/Tooltip.css';
import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Layout from './Layout';
import LoginPage from '../features/auth/LoginPage';
import SignupPage from '../features/auth/SignupPage';
import VerifyPage from '../features/auth/VerifyPage';
import ResetPasswordPage from '../features/auth/ResetPasswordPage';
import Dashboard from './Dashboard';

import { MessageProvider } from '../contexts/MessageContext';
import { MobileProvider } from '../contexts/MobileContext';
import { DropdownProvider } from '../contexts/DropdownContext';
import { SitesProvider } from '../contexts/SitesContext';
import { ThemeProvider } from '../contexts/ThemeContext';

const AppRoutes = () => {
  const location = useLocation();
  const authRoutes = ['/', '/signup', '/reset-password', '/verify'];
  const isAuthRoute = authRoutes.includes(location.pathname);

  return (
    <ThemeProvider forceDark={isAuthRoute}>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/verify" element={<VerifyPage />} />
        </Route>
        <Route path="/dashboard/*" element={<Dashboard />} />
      </Routes>
    </ThemeProvider>
  );
};

const App = () => {
  return (
    <MessageProvider>
      <MobileProvider>
        <DropdownProvider>
          <SitesProvider>
            <Router>
              <AppRoutes />
            </Router>
          </SitesProvider>
        </DropdownProvider>
      </MobileProvider>
    </MessageProvider>
  );
};

export default App;
